

export const readiness = {
    action: "mdi-eye",
    title: "Readiness",
    permission: "readiness",
    items: [

        {
            prefix: "O",
            title: "Readiness",
            link: "/readiness",
            permission: "readiness-index",
        },
        {
            prefix: "O",
            title: "NewReadiness",
            link: "/readiness/create",
            permission: "readiness-create",
        },
        {
            prefix: "O",
            title: "DamageReadiness",
            link: "/readiness-damage",
            permission: "readiness-damage-index",
        },
        {
            prefix: "O",
            title: "StreetReadiness",
            link: "/readiness-street",
            permission: "readiness-damage-index",
        },
    ],
}

